<ng-container [ngSwitch]="dynamicChart?.type">
    <ng-container *ngSwitchCase="'barChart'">
        <div id="chart-column-{{uniqueId}}"></div>
    </ng-container>
    <ng-container *ngSwitchCase="'lineChart'">
        <div id="chart-line-{{uniqueId}}"></div>
    </ng-container>
    <ng-container *ngSwitchCase="'pieChart'">
        <div id="chart-pie-{{uniqueId}}"></div>
    </ng-container>
    <ng-container *ngSwitchCase="'ganttChart'">
        <div id="chart-gantt-{{uniqueId}}"></div>
    </ng-container>
</ng-container>
